import Image from 'next/image';

export default function LoadMoreSpinner() {
  return (
    <div className="mt-4 flex justify-center">
      <Image
        loader={({ src }) => src}
        unoptimized
        width="100"
        height="100"
        alt=""
        src="/img/logo/Spinner.svg"
      />
    </div>
  );
}
